import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface Props {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: Props) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center bg-white border border-dashed border-zinc-200 rounded-xl px-6 py-12 sm:py-16',
        className,
      )}
    >
      {icon && (
        <div className="mb-4 h-11 w-11 rounded-full bg-zinc-100 flex items-center justify-center text-zinc-500">
          {icon}
        </div>
      )}
      <h3 className="text-[15px] font-semibold tracking-tightish text-zinc-900">{title}</h3>
      {description && (
        <p className="mt-1.5 text-[13px] text-zinc-500 max-w-sm leading-relaxed text-pretty">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
